//import api from '../api';
import { newAPIPost } from '../api/index.js';
import dateFormat from '../utils/dateFormat';

export default {
    state: {
        lockstage: [],
        searchRequest: null,
      },

      mutations: {
        updatelockstage(state, list) {
          state.lockstage = list;
        },
        updateSearchlockstageRequest(state, searchRequest) {
          state.searchRequest = searchRequest;
        },
      },

      actions: {
        async lockstage({ commit, state }, request) {
          const fallbackRequest = request || state.searchRequest;
          const requestToSend = JSON.parse(JSON.stringify(fallbackRequest))



 
          if (requestToSend.billingDate.startDate)
          {
              const date = moment(requestToSend.billingDate.startDate)
                          .endOf('d')
                          .toDate();
              console.log(date)
              console.log(date.getMonth())
              console.log(date.getDate())
              var month = (date.getMonth() + 1).toString()
              if (month.length === 1)
              {
                  month = '0' + month
              }
      
              var day = date.getDate().toString()
              if (day.length === 1)
              {
                  day = '0' + day
              }
              requestToSend.billingDate.startDate = date.getFullYear() + '-' + month + '-' + day
          }
      
          if (requestToSend.billingDate.endDate)
          {
              const date = moment(requestToSend.billingDate.endDate)
                          .endOf('d')
                          .toDate();
      
                          var month = (date.getMonth() + 1).toString()
                          if (month.length == 1)
                          {
                              month = '0' + month
                          }
                  
                          var day = date.getDate().toString()
                          if (day.length == 1)
                          {
                              day = '0' + day
                          }
              requestToSend.billingDate.endDate = date.getFullYear() + '-' + month + '-' + day
          }
          else
          {
            if (requestToSend.billingDate.startDate != null)
            {
              const date = moment(requestToSend.billingDate.startDate)
                          .endOf('d')
                          .toDate();
              console.log(date)
              console.log(date.getMonth())
              console.log(date.getDate())
              var month = (date.getMonth() + 1).toString()
              if (month.length === 1)
              {
                  month = '0' + month
              }
      
              var day = date.getDate().toString()
              if (day.length === 1)
              {
                  day = '0' + day
              }
      
              requestToSend.billingDate.endDate = date.getFullYear() + '-' + month + '-' + day
            }
              
          }


          console.log(requestToSend);

          // const validDate = requestToSend.validOn;
          // requestToSend.validOn = dateFormat.gstDateFormat(validDate);
            const st = performance.now();
            //const result = await api.post('/api/w/apar/stagelist', requestToSend);
            const result = await newAPIPost('/api/w/apar/stagelist', requestToSend);
            commit('updateSearchlockstageRequest', fallbackRequest);
            console.log(JSON.stringify(result));
            return commit('updatelockstage', result);
            
                },
      },


      getters: {
        getlockstage: state => state.lockstage,
      },
}